import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(state: RootState['colors'] = {}, action: Action): RootState['colors'] {
  switch (action.type) {
    case 'COLOR_UPSERT': {
      const newState = state

      Object.keys(action.payload).forEach((articleId) => {
        newState[articleId] = { ...state[articleId], ...action.payload[articleId] }
      })

      return newState
    }
    default:
      return state
  }
}
